export const loginStyles = {
	container: {
	  display: 'flex',
	  justifyContent: 'center',
	  alignItems: 'center',
	  minHeight: '100vh',
	  backgroundImage: 'linear-gradient(135deg, #3A8DFF 0%, #F5F5F5 100%)',
	},
	formContainer: {
	  background: 'rgba(255, 255, 255, 0.95)',
	  padding: '2rem',
	  borderRadius: '16px',
	  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
	  width: '100%',
	  maxWidth: '400px',
	},
	title: {
	  textAlign: 'center' as const,
	  color: '#2d3748',
	//   fontSize: '2rem',
	  fontWeight: '700',
	  marginBottom: '2rem',
	},
	input: {
	  width: '100%',
	  padding: '0.75rem',
	  marginBottom: '1rem',
	  border: '1px solid #e2e8f0',
	  borderRadius: '8px',
	  fontSize: '1rem',
	  transition: 'border-color 0.3s ease',
	  ':focus': {
		outline: 'none',
		borderColor: '#667eea',
		boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.2)',
	  },
	},
	button: {
	  width: '100%',
	  padding: '0.75rem',
	  background: '#667eea',
	  color: 'white',
	  border: '1px solid #667eea',
	  borderRadius: '8px',
	  fontSize: '1rem',
	  fontWeight: '600',
	  cursor: 'pointer',
	  transition: 'background 0.3s ease',
	  ':hover': {
		background: '#764ba2',
		borderColor: '#764ba2',
	  },
	  ':disabled': {
		background: '#cbd5e0',
		borderColor: '#cbd5e0',
		cursor: 'not-allowed',
	  },
	},
	error: {
	  color: '#e53e3e',
	  fontSize: '0.875rem',
	  marginTop: '0.5rem',
	  textAlign: 'center' as const,
	},
	loader: {
	  border: '3px solid #f3f3f3',
	  borderTop: '3px solid #667eea',
	  borderRadius: '50%',
	  width: '20px',
	  height: '20px',
	  animation: 'spin 1s linear infinite',
	},
};
   
  